import { parseCategoryHierarchy } from './categoryHelpers';

/**
 * Predefined categories for each listing type
 */
const CATEGORIES_FLAT = {
  Products: [
    'Arts, Craft & Books',
    'Deities & Paraphernalia',
    'Electronics & Instruments',
    'Electronics & Instruments > Laptops',
    'Electronics & Instruments > Mobile',
    'Electronics & Instruments > Musical Instruments',
    'Electronics & Instruments > Sound System',
    'Electronics & Instruments > TV & Appliances',
    'Fashion',
    'Fashion > Men',
    'Fashion > Women',
    'Fashion > Kids',
    'Fashion > Accessories & Jewellery',
    'Food and Wellness',
    'Food and Wellness > Cow Products',
    'Food and Wellness > Grocery & Gourmet Food',
    'Food and Wellness > Health & Beauty',
    'Gift ideas & Festive Combos',
    'Home, Kitchen & Living',
    'Home, Kitchen & Living > Kitchen Essential',
    'Home, Kitchen & Living > Home Furnishing',
    'Kids / Toys / Games',
    'Kids / Toys / Games > Toys & Games',
    'Kids / Toys / Games > Baby Products',
    'Sports, Fitness & Travel',
    'Sports, Fitness & Travel > Travel Essentials',
    'Sports, Fitness & Travel > Sports & Fitness',
    'Other Products'
  ],
  Services: [
    'Astrology',
    'Astrology > Astrology All',
    'Astrology > Birth Chart',
    'Astrology > Face Reading',
    'Astrology > Kundli Match',
    'Astrology > Palmistry',
    'Astrology > Tarrot Card Reading',
    'Deities',
    'Deities > Altars',
    'Deities > Backdrop Painting',
    'Deities > Deity Furniture',
    'Deities > Deity Dress',
    'Deities > Deity Jewellery',
    'Deities > Deity Painting',
    'Deities > Deity Paraphernalia',
    'Deities > Pujaris',
    'Deities > Sculptors',
    'Deities > Florist',
    'Fashion',
    'Fashion > Dress Designers',
    'Fashion > Tailors',
    'Fashion > Custom Jewellery',
    'Health & Wellness',
    'Health & Wellness > Yoga Trainer',
    'Health & Wellness > Fitness Trainer',
    'Health & Wellness > Doctors',
    'Health & Wellness > Physio',
    'Health & Wellness > Dentist',
    'Health & Wellness > Surgeons',
    'Health & Wellness > Care givers',
    'Health & Wellness > Massuer',
    'Health & Wellness > Hospitals & Nusring Homes',
    'Health & Wellness > Wellness Centers',
    'Home Utilities',
    'Home Utilities > Electrician',
    'Home Utilities > Plumber',
    'Home Utilities > Carpenter',
    'Home Utilities > Driver',
    'Home Utilities > Cooks',
    'Kirtan & Arts',
    'Kirtan & Arts > Kirtaniyas',
    'Kirtan & Arts > Drama',
    'Kirtan & Arts > Puppet Shows',
    'Kirtan & Arts > Rangoli',
    'Kirtan & Arts > Instrument Care',
    'Learn',
    'Learn > Astrological Sciences',
    'Learn > Academic Education',
    'Learn > Cooking Classes',
    'Learn > Deity Worship Training',
    'Learn > Kirtan',
    'Learn > Languages',
    'Learn > Music',
    'Learn > Schools & Universities',
    'Learn > Shastric Courses',
    'Learn > Vocational Training',
    'Learn > Workshops',
    'Learn > Others',
    'Plan Events',
    'Plan Events > Caterers',
    'Plan Events > Decorators',
    'Plan Events > Event Managers',
    'Plan Events > Florist / Flower Jewellery',
    'Plan Events > Hall / Venue',
    'Plan Events > Havan & Samskars',
    'Plan Events > Kirtan Groups',
    'Plan Events > Makeup Artists',
    'Plan Events > MCs & Celebrities',
    'Plan Events > Photo / Videography',
    'Plan Events > Others',
    'Prasadam',
    'Prasadam > Tiffin Services',
    'Prasadam > Restaurants & Cafes',
    'Prasadam > Home Chefs',
    'Prasadam > Catering',
    'Prasadam > Prasadam Distribution',
    'Professional Services',
    'Professional Services > Accountant',
    'Professional Services > Architect',
    'Professional Services > Astrologer',
    'Professional Services > Financial Advisor',
    'Professional Services > Insurance Advisor',
    'Professional Services > Lawyers',
    'Professional Services > Marketing Consultant',
    'Professional Services > Engineers',
    'Professional Services > Interior Designer',
    'Professional Services > Printers',
    'Professional Services > Real Estate Agent',
    'Professional Services > Graphic Designer',
    'Professional Services > Web/App Developer',
    'Professional Services > Software Developer',
    'Professional Services > Vastu Consultant',
    'Professional Services > Others',
    'Yatras',
    'Yatras > Travel Booking',
    'Yatras > Hotels / Ashrams',
    'Yatras > Home Stay',
    'Yatras > Hire Vehicle',
    'Yatras > Tour Guide',
    'Yatras > Tour Packages',
    'Yatras > Upcoming Yatras',
    'Others',
    'Others > Matrimonial sites',
    'Others > Milk Subscription'
  ],
  Rentals: [
    'Travel & Yatras',
    'Travel & Yatras > Pilgrimage Tours',
    'Travel & Yatras > Temple Visits',
    'Travel & Yatras > Group Tours',
    'Travel & Yatras > Travel Packages',
    'Home, Kitchen & Living',
    'Home, Kitchen & Living > Kitchen Essentials',
    'Home, Kitchen & Living > Home Furnishing',
    'Home, Kitchen & Living > Furniture',
    'Home, Kitchen & Living > Appliances',
    'Electronics & Instruments',
    'Electronics & Instruments > Laptops',
    'Electronics & Instruments > Mobile Phones',
    'Electronics & Instruments > Cameras',
    'Electronics & Instruments > Musical Instruments',
    'Electronics & Instruments > Sound Systems',
    'Electronics & Instruments > TV & Projectors',
    'Fashion',
    'Fashion > Traditional Wear',
    'Fashion > Jewelry',
    'Fashion > Accessories',
    'Sports, Fitness & Travel',
    'Sports, Fitness & Travel > Sports Equipment',
    'Sports, Fitness & Travel > Fitness Equipment',
    'Sports, Fitness & Travel > Travel Gear',
    'Other Rentals'
  ],
  Classifieds: [
    'Post an Ad',
    'Property Rent / Sale',
    'Matrimonial',
    'Business',
    'Services',
    'Recruitment',
    'Buy / Sell',
    'Yatra / Travel'
  ],
  Volunteering: [
    'Temple Seva',
    'Preaching Seva',
    'Vaishnav Seva',
    'Cow Seva',
    'Dham Seva',
    'Loka Seva'
  ],
  Events: [
    'Global Events',
    'Local Events',
    'House Programs',
    'Upcoming Festivals'
  ],
  Subscriptions: [
    'Food and Wellness',
    'Food and Wellness > Cow Products',
    'Food and Wellness > Grocery & Gourmet Food',
    'Prasadam',
    'Prasadam > Tiffin Services',
    'Home, Kitchen & Living',
    'Home, Kitchen & Living > Kitchen Essential',
    'Others > Milk Subscription',
    'Other Subscriptions'
  ]
};

/**
 * Get standard filter configuration for listing pages
 * @param {Array} listings - Array of listings
 * @param {String} listingType - Type of listing (Products, Services, etc.)
 * @param {Array} vendors - Array of vendors (optional)
 */
export const getListingFilters = (listings, listingType, vendors = []) => {
  const filters = [];

  // Category filter (Main categories only)
  const categoryData = getCategoriesForType(listings, listingType);
  filters.push({
    id: 'category',
    label: 'Category',
    type: 'checkbox',
    options: categoryData.mainCategories,
    cascadesWith: 'subcategory',
    categoryMap: categoryData.categoryMap
  });

  // Subcategory filter (Dynamic based on category selection)
  filters.push({
    id: 'subcategory',
    label: 'Sub-Category',
    type: 'checkbox',
    options: [], // Will be populated dynamically
    dependsOn: 'category',
    categoryMap: categoryData.categoryMap
  });

  // Vendor filter (All types)
  if (vendors.length > 0) {
    filters.push({
      id: 'vendor',
      label: 'Vendor',
      type: 'checkbox',
      options: vendors.map(v => ({
        id: v.id,
        label: v.name || v.email,
        count: listings.filter(l => l.vendor_id === v.id).length
      }))
    });
  }

  // Price filter (All except Volunteering)
  if (listingType !== 'Volunteering') {
    filters.push({
      id: 'price',
      label: 'Price Range (₹)',
      type: 'slider',
      min: 0,
      max: 100000,
      minPlaceholder: '0',
      maxPlaceholder: '100000',
      unit: 'Price in Rupees'
    });
  }

  // Location filter (All types)
  filters.push({
    id: 'location',
    label: 'Location (City, State)',
    type: 'text',
    placeholder: 'Enter city, state, or pincode'
  });

  // Markets filter (All types)
  filters.push({
    id: 'markets',
    label: 'Target Markets',
    type: 'checkbox',
    options: [
      { id: 'B2C', label: 'B2C (Consumer)', count: listings.filter(l => l.markets?.includes('B2C')).length },
      { id: 'B2B', label: 'B2B (Business)', count: listings.filter(l => l.markets?.includes('B2B')).length },
      { id: 'Wholesale', label: 'Wholesale', count: listings.filter(l => l.markets?.includes('Wholesale')).length },
      { id: 'Retail', label: 'Retail', count: listings.filter(l => l.markets?.includes('Retail')).length }
    ]
  });

  // Star Rating filter (All types if reviewable)
  filters.push({
    id: 'rating',
    label: 'Avg. Star Rating',
    type: 'slider',
    min: 0,
    max: 5,
    minPlaceholder: '0',
    maxPlaceholder: '5',
    unit: 'Rating (⭐0 to ⭐5)'
  });

  // Tax Information filter (Products, Services, Rentals)
  if (['Products', 'Services', 'Rentals'].includes(listingType)) {
    filters.push({
      id: 'taxInfo',
      label: 'Tax Information',
      type: 'checkbox',
      options: [
        { id: 'gst', label: 'GST Provided', count: listings.filter(l => l.hsn_sac_code).length },
        { id: 'pan', label: 'PAN Verified', count: listings.filter(l => l.tax_info?.pan_verified).length }
      ]
    });
  }

  // Subscription-specific filter
  if (listingType === 'Subscriptions') {
    filters.push({
      id: 'billingCycle',
      label: 'Billing Cycle',
      type: 'checkbox',
      options: [
        { id: 'monthly', label: 'Monthly', count: listings.filter(l => l.data?.billing_cycle === 'monthly').length },
        { id: 'quarterly', label: 'Quarterly', count: listings.filter(l => l.data?.billing_cycle === 'quarterly').length },
        { id: 'annually', label: 'Annually', count: listings.filter(l => l.data?.billing_cycle === 'annually').length }
      ]
    });
  }

  // Inventory Status filter (Products, Rentals, Services)
  if (['Products', 'Rentals', 'Services'].includes(listingType)) {
    filters.push({
      id: 'inventory',
      label: 'Inventory Status',
      type: 'checkbox',
      options: [
        { id: 'inStock', label: 'In Stock', count: listings.filter(l => (l.data?.inventory || 0) > 10).length },
        { id: 'lowStock', label: 'Low Stock', count: listings.filter(l => {
          const inv = l.data?.inventory || 0;
          return inv > 0 && inv <= 10;
        }).length },
        { id: 'outOfStock', label: 'Out of Stock', count: listings.filter(l => (l.data?.inventory || 0) === 0).length }
      ]
    });
  }

  // Event Date filter (Events only)
  if (listingType === 'Events') {
    filters.push({
      id: 'eventDate',
      label: 'Event Date',
      type: 'checkbox',
      options: [
        { id: 'upcoming', label: 'Upcoming Events' },
        { id: 'thisWeek', label: 'This Week' },
        { id: 'thisMonth', label: 'This Month' },
        { id: 'past', label: 'Past Events' }
      ]
    });
  }

  return filters;
};

/**
 * Get categories for specific listing type with counts
 * Returns both main categories and subcategories separately
 */
const getCategoriesForType = (listings, listingType) => {
  const categoriesFlat = CATEGORIES_FLAT[listingType] || [];
  const { mainCategories, categoryMap } = parseCategoryHierarchy(categoriesFlat);
  
  // Count listings for each main category
  const mainCategoryFilters = mainCategories.map(category => {
    const count = listings.filter(l => {
      // Check if listing's category matches this main category
      // Either exact match or the listing's category starts with this category
      if (l.category === category) return true;
      if (l.category && l.category.includes(' > ')) {
        const listingMainCat = l.category.split(' > ')[0].trim();
        return listingMainCat === category;
      }
      return false;
    }).length;
    
    return {
      id: category,
      label: category,
      count
    };
  });

  return {
    mainCategories: mainCategoryFilters,
    categoryMap
  };
};

/**
 * Get unique categories from listings (fallback)
 */
const getUniqueCategories = (listings) => {
  const categoryMap = new Map();
  
  listings.forEach(listing => {
    const category = listing.category;
    if (category) {
      if (!categoryMap.has(category)) {
        categoryMap.set(category, 0);
      }
      categoryMap.set(category, categoryMap.get(category) + 1);
    }
  });

  return Array.from(categoryMap.entries()).map(([category, count]) => ({
    id: category,
    label: category,
    count
  }));
};

/**
 * Apply filters to listings
 */
export const applyListingFilters = (listings, appliedFilters, listingType) => {
  let filtered = [...listings];
  const { selectedFilters, rangeValues } = appliedFilters;

  // Category filter
  if (selectedFilters.category?.length > 0) {
    filtered = filtered.filter(listing => {
      // Check if listing category matches any selected category
      return selectedFilters.category.some(selectedCat => {
        // Exact match
        if (listing.category === selectedCat) return true;
        // Parent category match (e.g., "Fashion" matches "Fashion > Men")
        if (listing.category?.startsWith(selectedCat + ' >')) return true;
        // Subcategory match
        if (listing.subcategory === selectedCat) return true;
        return false;
      });
    });
  }

  // Vendor filter
  if (selectedFilters.vendor?.length > 0) {
    filtered = filtered.filter(listing =>
      selectedFilters.vendor.includes(listing.vendor_id)
    );
  }

  // Price filter
  if (rangeValues.price && listingType !== 'Volunteering') {
    const min = rangeValues.price.min ? parseFloat(rangeValues.price.min) : 0;
    const max = rangeValues.price.max ? parseFloat(rangeValues.price.max) : Infinity;
    filtered = filtered.filter(listing => {
      const price = listing.data?.price || listing.price || 0;
      return price >= min && price <= max;
    });
  }

  // Location filter
  if (rangeValues.location?.value) {
    const locationQuery = rangeValues.location.value.toLowerCase();
    filtered = filtered.filter(listing =>
      listing.location?.city?.toLowerCase().includes(locationQuery) ||
      listing.location?.state?.toLowerCase().includes(locationQuery) ||
      listing.location?.pincode?.toLowerCase().includes(locationQuery)
    );
  }

  // Markets filter
  if (selectedFilters.markets?.length > 0) {
    filtered = filtered.filter(listing => {
      const markets = listing.markets || [];
      return selectedFilters.markets.some(market => markets.includes(market));
    });
  }

  // Star Rating filter
  if (rangeValues.rating) {
    const min = rangeValues.rating.min ? parseFloat(rangeValues.rating.min) : 0;
    const max = rangeValues.rating.max ? parseFloat(rangeValues.rating.max) : 5;
    filtered = filtered.filter(listing => {
      const rating = listing.average_rating || 0;
      return rating >= min && rating <= max;
    });
  }

  // Tax Information filter
  if (selectedFilters.taxInfo?.length > 0 && ['Products', 'Services', 'Rentals'].includes(listingType)) {
    filtered = filtered.filter(listing => {
      return selectedFilters.taxInfo.some(tax => {
        if (tax === 'gst') return listing.hsn_sac_code;
        if (tax === 'pan') return listing.tax_info?.pan_verified;
        return false;
      });
    });
  }

  // Billing Cycle filter (Subscriptions)
  if (selectedFilters.billingCycle?.length > 0 && listingType === 'Subscriptions') {
    filtered = filtered.filter(listing =>
      selectedFilters.billingCycle.includes(listing.data?.billing_cycle)
    );
  }

  // Inventory Status filter
  if (selectedFilters.inventory?.length > 0 && ['Products', 'Rentals', 'Services'].includes(listingType)) {
    filtered = filtered.filter(listing => {
      const inventory = listing.data?.inventory || 0;
      return selectedFilters.inventory.some(status => {
        if (status === 'inStock') return inventory > 10;
        if (status === 'lowStock') return inventory > 0 && inventory <= 10;
        if (status === 'outOfStock') return inventory === 0;
        return false;
      });
    });
  }

  // Event Date filter
  if (selectedFilters.eventDate?.length > 0 && listingType === 'Events') {
    const now = new Date();
    filtered = filtered.filter(listing => {
      const eventDate = new Date(listing.data?.startDate);
      return selectedFilters.eventDate.some(filter => {
        if (filter === 'upcoming') return eventDate >= now;
        if (filter === 'thisWeek') {
          const weekFromNow = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
          return eventDate >= now && eventDate <= weekFromNow;
        }
        if (filter === 'thisMonth') {
          return eventDate.getMonth() === now.getMonth() && eventDate.getFullYear() === now.getFullYear();
        }
        if (filter === 'past') return eventDate < now;
        return false;
      });
    });
  }

  return filtered;
};
